import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Edit,
  Loader,
  Lock,
  Plus,
  PlusCircle,
  Search,
  ShieldCheck,
  SortAsc,
  Trash,
  UserCog,
  UserPlus,
} from "lucide-react";
import { useState } from "react";
import Pagination from "../../shared/Pagination";
import { useNavigate } from "react-router-dom";
import AddUser from "../../components/add-user/AddUser";
import ReviewAddUser from "../../components/add-user/ReviewAddUser";
import AddUserSuccess from "../../components/add-user/AddUserSuccess";
import { SkeletonUsersPage } from "../../skeletons/UsersSkeleton";
import { useFormattedDate } from "../../hooks/useFormattedDate";
import { deleteUser, getAllUsers } from "../../sdk/users/users";
import { useError } from "../../context/ErrorProvider";
import { useQuery } from "react-query";
import {
  addModule,
  addModulePermission,
  addRole,
  deleteRole,
  editRole,
  getRoles,
} from "../../sdk/roles/roles";
import { getModules } from "../../sdk/modules/modules";
import ViewUsers from "../../components/admin-users/ViewUsers";
import AddRoleInformation from "../../components/add-role/AddRoleInformation";
import AddPermissions from "../../components/add-role/AddPermissions";
import ReviewAddRole from "../../components/add-role/ReviewAddRole";
import { useMutation } from "react-query";
import AddRoleSuccess from "../../components/add-role/AddRoleSuccess";
import UserFilter from "../../components/filter/UserFilter";
import Loading from "../../shared/Loading";
import EditRoleInformation from "../../components/edit-role/EditRoleInformation";
import EditPermissions from "../../components/edit-role/EditPermissions";
import ReviewEditRole from "../../components/edit-role/ReviewEditRole";
import EditRoleSuccess from "../../components/edit-role/EditRoleSuccess";
import PromptDeleteRole from "../../components/delete-role/DeleteRole";
import DeleteRoleSuccess from "../../components/delete-role/DeleteRoleSuccess";
import { hasPermission } from "../../utils/permissions";
import useAuth from "../../hooks/useAuth";
import AddModule from "../../components/add-module/AddModule";
import AddModuleSuccess from "../../components/add-module/AddModuleSuccess";
import AddModulePermission from "../../components/add-permission/AddModulePermission";
import AddModulePermissionSuccess from "../../components/add-permission/AddModulePermissionSuccess";

const Users = () => {
  const [expandedModules, setExpandedModules] = useState({});

  const toggleExpandModule = (moduleId) => {
    setExpandedModules((prev) => ({
      ...prev,
      [moduleId]: !prev[moduleId],
    }));
  };
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [fromDate, setFromDate] = useState(new Date("2023-11-23"));
  const [toDate, setToDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  const [branch, setBranch] = useState("");
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState("users");
  const navigate = useNavigate();
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openAddUserSuccess, setOpenAddUserSuccess] = useState(false);
  const [openReviewAddUser, setOpenReviewAddUser] = useState(false);
  const { showError } = useError();
  const [totalItems, setTotalItems] = useState(0);
  const [adminUser, setAdminUser] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: null,
    branch: null,
    profileUrl: "",
  });
  const [errors, setErrors] = useState({});
  const handlePageChange = (page) => {
    setPage(page);
  };
  const { auth } = useAuth();
  const [totalPages, setTotalPages] = useState(0);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [openViewUsers, setOpenViewUsers] = useState(false);
  const [roleUsers, setRoleUsers] = useState([]);
  const [openAddRoleInformation, setOpenAddRoleInformation] = useState(false);
  const [openAddRolePermissions, setOpenAddRolePermissions] = useState(false);
  const [openReviewAddRole, setOpenReviewAddRole] = useState(false);
  const [openAddRoleSuccess, setOpenAddRoleSuccess] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [editActiveIndex, setEditActiveIndex] = useState(0);
  const [selectedRole, setSelectedRole] = useState({});
  const [myRole, setMyRole] = useState({
    roleName: "",
    roleDescription: "",
    permissions: [],
    users: [],
  });
  const [editRoleDetails, setEditRoleDetails] = useState({
    roleName: "",
    roleDescription: "",
    permissions: [],
    users: [],
  });
  const [openEditRoleInformation, setOpenEditRoleInformation] = useState(false);
  const [openEditSetPermissions, setOpenEditSetPermissions] = useState(false);
  const [openReviewEditRole, setOpenReviewEditRole] = useState(false);
  const [openEditRoleSuccess, setOpenEditRoleSuccess] = useState(false);
  const [openPromptDeleteRole, setOpenPromptDeleteRole] = useState(false);
  const [openDeleteRoleSuccess, setOpenDeleteRoleSuccess] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState({});
  const [openAddModule, setOpenAddModule] = useState(false);
  const [openAddModulePermission, setOpenAddModulePermission] = useState(false);
  const [openAddModulePermissionSuccess, setOpenAddModulePermissionSuccess] =
    useState(false);
  const [openAddModuleSuccess, setOpenAddModuleSuccess] = useState(false);
  const [selectedModule, setSelectedModule] = useState({});
  const [myModule, setMyModule] = useState({
    name: "",
    description: "",
  });

  const [myPermission, setMyPermission] = useState({
    name: "",
    description: "",
  });

  const toggleAddModule = () => {
    setOpenAddModule(true);
  };
  const closeAddModule = () => {
    setOpenAddModule(false);
  };

  const toggleAddModuleSuccess = () => {
    setOpenAddModuleSuccess(true);
  };
  const closeAddModuleSuccess = () => {
    setOpenAddModuleSuccess(false);
  };

  const toggleAddModulePermission = (module) => {
    setSelectedModule(module);
    setOpenAddModulePermission(true);
  };
  const closeAddModulePermission = () => {
    setOpenAddModulePermission(false);
  };

  const toggleAddModulePermissionSuccess = () => {
    setOpenAddModulePermissionSuccess(true);
  };
  const closeAddModulePermissionSuccess = () => {
    setOpenAddModulePermissionSuccess(false);
  };

  const { mutate: addModuleMutate, isLoading: loadingAddModule } = useMutation({
    mutationKey: ["add module"],
    mutationFn: () => addModule(myModule?.name, myModule?.description),
    onSuccess: () => {
      refetchModules();
      refetchRoles();
      closeAddModule();
      toggleAddModuleSuccess();
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleAddModule = () => {
    addModuleMutate();
  };

  const { mutate: addModulePermissionMutate, isLoading: loadingAddPermission } =
    useMutation({
      mutationKey: ["Add a permission"],
      mutationFn: () =>
        addModulePermission(
          myPermission?.name,
          selectedModule?.id,
          selectedModule?.name,
        ),
      onSuccess: () => {
        refetchModules();
        refetchRoles();
        closeAddModulePermission();
        toggleAddModulePermissionSuccess();
      },
      onError: (error) => {
        showError(error?.response?.data?.message || error.message);
      },
    });

  const handleAddModulePermission = () => {
    addModulePermissionMutate();
  };

  const togglePromptDeleteRole = (role) => {
    setRoleToDelete(role);
    setOpenPromptDeleteRole(true);
  };
  const closePromptDeleteRole = () => {
    setOpenPromptDeleteRole(false);
  };

  const { mutate: deleteRoleMutate, isLoading: loadingDeleteRole } =
    useMutation({
      mutationKey: ["delete role"],
      mutationFn: () => deleteRole(roleToDelete?.id),
      onSuccess: () => {
        refetchModules();
        refetchRoles();
        closePromptDeleteRole();
        toggleDeleteRoleSuccess();
      },
      onError: (error) => {
        showError(error?.response?.data?.message || error.message);
      },
    });

  const handleContinueDeleting = () => {
    deleteRoleMutate();
  };

  const toggleDeleteRoleSuccess = () => {
    setOpenDeleteRoleSuccess(true);
  };
  const closeDeleteRoleSuccess = () => {
    setOpenDeleteRoleSuccess(false);
  };

  const toggleEditRoleInformation = (role) => {
    const permissionIds = role?.permissions?.map((p) => p.id) || [];
    const userIds = role?.users?.map((user) => user?.id) || [];
    setSelectedRole(role);
    setEditActiveIndex(0);
    setEditRoleDetails({
      roleName: role?.name,
      roleDescription: role?.description,
      permissions: permissionIds,
      users: userIds,
    });
    setOpenEditRoleInformation(true);
  };

  const closeEditRoleInformation = () => {
    setOpenEditRoleInformation(false);
  };

  const handleEditSetPermissions = () => {
    setEditActiveIndex(1);
    closeEditRoleInformation();
    toggleEditSetPermissions();
  };

  const toggleEditSetPermissions = () => {
    setOpenEditSetPermissions(true);
  };
  const closeEditSetPermissions = () => {
    setOpenEditSetPermissions(false);
  };

  const handleReviewEditRole = () => {
    setEditActiveIndex(2);
    closeEditSetPermissions();
    toggleReviewEditRole();
  };

  const toggleReviewEditRole = () => {
    setOpenReviewEditRole(true);
  };
  const closeReviewEditRole = () => {
    setOpenReviewEditRole(false);
  };

  const toggleEditRoleSuccess = () => {
    setOpenEditRoleSuccess(true);
  };
  const closeEditRoleSuccess = () => {
    setOpenEditRoleSuccess(false);
  };

  const { mutate: editRoleMutate, isLoading: editRoleLoading } = useMutation({
    mutationKey: ["edit role"],
    mutationFn: () =>
      editRole(
        selectedRole?.id,
        editRoleDetails.roleName,
        editRoleDetails?.roleDescription,
        editRoleDetails.permissions,
        editRoleDetails.users,
      ),
    onSuccess: () => {
      closeReviewEditRole();
      refetchModules();
      refetchRoles();
      toggleEditRoleSuccess();
      setEditRoleDetails({
        roleName: "",
        roleDescription: "",
        permissions: [],
        users: [],
      });
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleEditRole = () => {
    editRoleMutate();
  };

  const handleCheckboxChange = (e, userId) => {
    e.stopPropagation();

    if (e.target.checked) {
      setSelectedUsers((prev) => [...prev, userId]);
    } else {
      setSelectedUsers((prev) => prev.filter((id) => id !== userId));
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(users.map((user) => user.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const isSelected = (userId) => selectedUsers.includes(userId);
  const formattedDate = useFormattedDate();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleAddRoleInformation = () => {
    setActiveIndex(0);
    setOpenAddRoleInformation(true);
  };
  const closeAddRoleInformation = () => {
    setOpenAddRoleInformation(false);
  };

  const toggleOpenReviewAddRole = () => {
    setOpenReviewAddRole(true);
  };
  const closeOpenReviewAddRole = () => {
    setOpenReviewAddRole(false);
  };

  const toggleAddRolePermissions = () => {
    setOpenAddRolePermissions(true);
  };
  const closeAddRolePermissions = () => {
    setOpenAddRolePermissions(false);
  };

  const toggleAddRoleSuccess = () => {
    setOpenAddRoleSuccess(true);
  };
  const closeAddRoleSuccess = () => {
    setOpenAddRoleSuccess(false);
  };

  const handleCollectPermissions = () => {
    setActiveIndex(1);
    closeAddRoleInformation();
    toggleAddRolePermissions();
  };

  const handleReviewAddRole = () => {
    setActiveIndex(2);
    closeAddRolePermissions();
    toggleOpenReviewAddRole();
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const toggleViewUsers = (users) => {
    setRoleUsers(users);
    setOpenViewUsers(true);
  };

  const closeViewUsers = () => {
    setOpenViewUsers(false);
  };

  const toggleAddUser = () => {
    setOpenAddUser(true);
  };
  const closeAddUser = () => {
    setOpenAddUser(false);
  };
  const toggleReviewAddUser = () => {
    setOpenReviewAddUser(true);
  };
  const closeReviewAddUser = () => {
    setOpenReviewAddUser(false);
  };

  const handleBackToAddUser = () => {
    closeReviewAddUser();
    toggleAddUser();
  };

  const toggleAddUserSuccess = () => {
    setOpenAddUserSuccess(true);
  };
  const closeAddUserSuccess = () => {
    setOpenAddUserSuccess(false);
  };

  const handleReviewAddUser = () => {
    closeReviewAddUser();
    toggleAddUserSuccess();
  };

  const handleCollectUserInformation = () => {
    const newErrors = {};

    if (!adminUser.firstName) newErrors.firstName = "First name is required";
    if (!adminUser.email) newErrors.email = "Email is required";
    if (!adminUser.phoneNumber)
      newErrors.phoneNumber = "Phone number is required";
    if (!adminUser.branch) newErrors.branch = "Branch is required";
    if (!adminUser.role) newErrors.role = "Role is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    closeAddUser();
    toggleReviewAddUser();
  };

  const { data: allRoles, refetch: refetchRoles } = useQuery({
    queryKey: ["roles"],
    queryFn: () => getRoles(),
  });

  const { data: allModules, refetch: refetchModules } = useQuery({
    queryKey: ["modules"],
    queryFn: () => getModules(),
    initialData: [],
  });

  const { refetch, isRefetching, isLoading } = useQuery({
    queryKey: ["users", page, limit, fromDate, toDate, status, role],
    queryFn: async () => {
      const response = await getAllUsers(
        page,
        limit,
        fromDate ? fromDate.toISOString() : null,
        toDate ? toDate.toISOString() : null,
        search,
        status,
        role,
      );
      return response.data.data;
    },
    onSuccess: (data) => {
      setUsers(data.items);
      setPage(data.meta.currentPage);
      setTotalPages(data.meta.totalPages);
      setLimit(data.meta.itemsPerPage);
      setTotalItems(data.meta.totalItems);
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const { mutate: addRoleMutate, isLoading: addRoleLoading } = useMutation({
    mutationKey: ["add role"],
    mutationFn: () =>
      addRole(
        myRole.roleName,
        myRole?.roleDescription,
        myRole.permissions,
        myRole.users,
      ),
    onSuccess: (data) => {
      closeOpenReviewAddRole();
      toggleAddRoleSuccess();
      setMyRole({
        roleName: "",
        roleDescription: "",
        permissions: [],
        users: [],
      });
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const { mutate: deleteUserMutate } = useMutation({
    mutationKey: ["delete user"],
    mutationFn: (id) => deleteUser(id),
    onSuccess: () => {
      refetchModules();
      refetchRoles();
      refetch();
      closeViewUsers();
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleDeleteUser = (id) => {
    deleteUserMutate(id);
  };

  const handleSubmitAddRole = () => {
    addRoleMutate();
  };

  const checkPermission = (role, permission) => {
    return role.permissions.some(
      (rolePermission) => rolePermission.id === permission.id,
    );
  };

  const toggleUserFilter = () => {
    setOpenFilter(true);
  };

  const closeUserFilter = () => {
    setOpenFilter(false);
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalItems);

  return (
    <>
      {openAddModulePermissionSuccess && (
        <AddModulePermissionSuccess
          closeAddModulePermissionSuccess={closeAddModulePermissionSuccess}
        />
      )}
      {openAddModulePermission && (
        <AddModulePermission
          closeAddModulePermission={closeAddModulePermission}
          loading={loadingAddPermission}
          handleAddModulePermission={handleAddModulePermission}
          myPermission={myPermission}
          setMyPermission={setMyPermission}
        />
      )}
      {openAddModuleSuccess && (
        <AddModuleSuccess closeAddModuleSuccess={closeAddModuleSuccess} />
      )}
      {openAddModule && (
        <AddModule
          closeAddModule={closeAddModule}
          loading={loadingAddModule}
          handleAddModule={handleAddModule}
          myModule={myModule}
          setMyModule={setMyModule}
        />
      )}
      {openDeleteRoleSuccess && (
        <DeleteRoleSuccess closeDeleteRoleSuccess={closeDeleteRoleSuccess} />
      )}
      {openPromptDeleteRole && (
        <PromptDeleteRole
          closePromptDeleteRole={closePromptDeleteRole}
          handleContinueDeleting={handleContinueDeleting}
          loading={loadingDeleteRole}
        />
      )}
      {openEditRoleSuccess && (
        <EditRoleSuccess closeAddRoleSuccess={closeEditRoleSuccess} />
      )}
      {openReviewEditRole && (
        <ReviewEditRole
          closeRoleModal={closeReviewEditRole}
          activeIndex={editActiveIndex}
          handleNextStep={handleEditRole}
          finishText="Edit Role"
          loading={editRoleLoading}
          myRole={editRoleDetails}
        />
      )}
      {openEditSetPermissions && (
        <EditPermissions
          closeRoleModal={closeEditSetPermissions}
          activeIndex={editActiveIndex}
          handleNextStep={handleReviewEditRole}
          finishText="Next"
          loading={false}
          myRole={editRoleDetails}
          setMyRole={setEditRoleDetails}
        />
      )}
      {openEditRoleInformation && (
        <EditRoleInformation
          closeRoleModal={closeEditRoleInformation}
          activeIndex={editActiveIndex}
          handleNextStep={handleEditSetPermissions}
          finishText="Next"
          loading={false}
          myRole={editRoleDetails}
          setMyRole={setEditRoleDetails}
        />
      )}
      {openFilter && (
        <UserFilter
          closeFilters={closeUserFilter}
          status={status}
          setStatus={setStatus}
          selectedRole={role}
          setSelectedRole={setRole}
          selectedBranch={branch}
          setSelectedBranch={setBranch}
          selectedGender={gender}
          setSelectedGender={setGender}
          handleApplyFilter={closeUserFilter}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
        />
      )}
      {openAddRoleInformation && (
        <AddRoleInformation
          closeRoleModal={closeAddRoleInformation}
          activeIndex={activeIndex}
          handleNextStep={handleCollectPermissions}
          loading={false}
          finishText="Next"
          myRole={myRole}
          setMyRole={setMyRole}
        />
      )}

      {openAddRolePermissions && (
        <AddPermissions
          closeRoleModal={closeAddRolePermissions}
          activeIndex={activeIndex}
          handleNextStep={handleReviewAddRole}
          loading={false}
          finishText="Next"
          myRole={myRole}
          setMyRole={setMyRole}
        />
      )}

      {openReviewAddRole && (
        <ReviewAddRole
          closeRoleModal={closeOpenReviewAddRole}
          activeIndex={activeIndex}
          handleNextStep={handleSubmitAddRole}
          loading={addRoleLoading}
          finishText="Next"
          myRole={myRole}
        />
      )}

      {openAddRoleSuccess && (
        <AddRoleSuccess closeAddRoleSuccess={closeAddRoleSuccess} />
      )}

      {openViewUsers && (
        <ViewUsers
          closeViewUsers={closeViewUsers}
          roleUsers={roleUsers}
          deleteUser={handleDeleteUser}
        />
      )}
      {openAddUser && (
        <AddUser
          closeAddUser={closeAddUser}
          handleCollectUserInformation={handleCollectUserInformation}
          adminUser={adminUser}
          setAdminUser={setAdminUser}
          errors={errors}
          setErrors={setErrors}
        />
      )}

      {openReviewAddUser && (
        <ReviewAddUser
          closeReviewAddUser={closeReviewAddUser}
          handleReviewAddUser={handleReviewAddUser}
          adminUser={adminUser}
          getUsers={refetch}
          setAdminUser={setAdminUser}
          handleBackToAddUser={handleBackToAddUser}
        />
      )}

      {openAddUserSuccess && (
        <AddUserSuccess closeAddUserSuccess={closeAddUserSuccess} />
      )}

      {isLoading ? (
        <SkeletonUsersPage />
      ) : (
        <div className="w-full pl-[10px]">
          <div
            onClick={() => navigate(-1)}
            className="flex items-center my-[10px] gap-[10px] cursor-pointer"
          >
            <ChevronLeft color="#000000" size={22} />
            <p className="text-[#222222] font-bold text-[16px]">Users</p>
          </div>
          <div className="h-[40px] flex items-center justify-between bg-white w-full">
            <div
              onClick={() => setActiveTab("users")}
              className={`w-[33%] text-[#222222] text-[16px] font-normal h-full flex items-center justify-center cursor-pointer ${
                activeTab === "users"
                  ? "bg-[#FFDEDE] border-b-[5px] border-[#000000]"
                  : "bg-white"
              }`}
            >
              Users
            </div>
            <div
              onClick={() => setActiveTab("roles")}
              className={`w-[33%] text-[#222222] text-[16px] font-normal h-full flex items-center justify-center cursor-pointer ${
                activeTab === "roles"
                  ? "bg-[#FFDEDE] border-b-[5px] border-[#000000]"
                  : "bg-white"
              }`}
            >
              Roles
            </div>
            <div
              onClick={() => setActiveTab("permissions")}
              className={`w-[33%] text-[#222222] text-[16px] font-normal h-full flex items-center justify-center cursor-pointer ${
                activeTab === "permissions"
                  ? "bg-[#FFDEDE] border-b-[5px] border-[#000000]"
                  : "bg-white"
              }`}
            >
              Permissions
            </div>
          </div>
          {activeTab === "users" && (
            <>
              <div className="flex my-[20px] items-end justify-between">
                <div>
                  <p className="text-[#222222] text-[20px] font-semibold">
                    Manage Users
                  </p>
                  <p className="text-[#000000] font-light text-[14px]">
                    Oversee and control user accounts
                  </p>
                </div>
                {hasPermission(
                  auth?.roles,
                  "0273d16d-7d1a-df83-0a46-1e4cac563e9a",
                ) && (
                  <button
                    onClick={toggleAddUser}
                    className="bg-[#000000] h-[40px] rounded-[30px] text-[#ffffff] text-[14px] font-normal px-[20px] flex items-center justify-center gap-[5px]"
                  >
                    <Plus size={16} color="#ffffff" />
                    Add a New User
                  </button>
                )}
              </div>
              <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
                <button
                  onClick={refetch}
                  className="h-[40px] w-[117px] flex items-center justify-center gap-[5px] border border-[#00A676] bg-white rounded-[10px] text-[#00A676] font-medium text-[15px]"
                >
                  {isRefetching ? <Loading /> : <Loader size={17} />}
                  Update
                </button>
                <div className="h-[40px] w-[117px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-white flex items-center justify-center">
                  {selectedUsers?.length} Selected
                </div>
                <div
                  onClick={toggleUserFilter}
                  className="h-[40px] cursor-pointer w-[127px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-[#FBF5F5] flex items-center justify-center gap-[5px]"
                >
                  <SortAsc color="#000000" />
                  <span className="text-[#000000]">Filter</span>
                  <span className="text-[#000000]">0</span>
                </div>
                <div className="flex items-center border border-gray-300 rounded-md px-2 h-[40px] w-[50%] bg-white">
                  <Search className="text-gray-500 w-5 h-5 mr-2" />
                  <input
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search users"
                    className="w-full outline-none text-sm text-gray-700 placeholder-gray-400 bg-transparent"
                  />
                  <button
                    onClick={refetch}
                    className="ml-2 p-2 bg-blue-600 rounded-md hover:bg-blue-700"
                  >
                    <Search className="w-4 h-4 text-white" />
                  </button>
                </div>
                <p className="text-[#000000] text-[15px] truncate font-normal">
                  {users?.length ?? 0} Results
                </p>
              </div>
              <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] mb-[10px] flex items-center">
                <div className="w-[3%]">
                  <input
                    type="checkbox"
                    name="loan"
                    id="loan"
                    onChange={handleSelectAll}
                    checked={selectedUsers.length === users.length}
                  />
                </div>
                <div className="w-[8%] text-[#000] truncate font-bold text-[14px]">
                  USER ID
                </div>
                <div className="w-[12%] text-[#000] truncate font-bold text-[14px]">
                  FULL NAME
                </div>
                <div className="w-[19%] text-[#000] truncate font-bold text-[14px]">
                  EMAIL
                </div>
                <div className="w-[10%] text-[#000] truncate font-bold text-[14px]">
                  MOBILE
                </div>
                <div className="w-[10%] text-[#000] truncate font-bold text-[14px]">
                  BRANCH
                </div>
                <div className="w-[10%] text-[#000] truncate font-bold text-[14px]">
                  ROLE
                </div>
                <div className="w-[10%] text-[#000] truncate font-bold text-[14px]">
                  CREATED ON
                </div>
                <div className="w-[10%] text-[#000] truncate font-bold text-[14px]">
                  UPDATED AT
                </div>
                <div className="w-[8%] text-[#000] truncate font-bold text-[14px]">
                  STATUS
                </div>
              </div>
              {users?.length > 0 ? (
                users?.map((user, index) => (
                  <div
                    key={user?.id}
                    className="h-[40px] px-[10px] w-full bg-[#ffffff] mb-[7px] flex items-center"
                  >
                    <div className="w-[3%]">
                      <input
                        type="checkbox"
                        name={`user-${index}`}
                        checked={isSelected(user.id)}
                        onChange={(e) => handleCheckboxChange(e, user.id)}
                      />
                    </div>
                    <div
                      onClick={() => navigate(`/dashboard/users/${user?.id}`)}
                      className="w-[8%] text-[#2A8C52] truncate cursor-pointer font-normal text-[14px]"
                    >
                      {user?.public_id}
                    </div>
                    <div className="w-[12%] text-[#000] truncate font-normal text-[14px]">
                      {user?.firstname} {user.lastname}
                    </div>
                    <div className="w-[19%] truncate truncate text-[#000] font-normal text-[14px]">
                      {user?.email}
                    </div>
                    <div className="w-[10%] truncate truncate text-[#000] font-normal text-[14px]">
                      {user?.phone ?? "N/A"}
                    </div>
                    <div className="w-[10%] truncate truncate text-[#000] font-normal text-[14px]">
                      {user?.branch?.name ?? "N/A"}
                    </div>
                    <div className="w-[10%] text-[#000] font-normal text-[14px]">
                      {user?.role?.name}
                    </div>
                    <div className="w-[10%] text-[#000] truncate font-normal text-[14px]">
                      {formattedDate(user?.createdAt)}
                    </div>
                    <div className="w-[10%] text-[#000] truncate font-normal text-[14px]">
                      {formattedDate(user?.updatedAt)}
                    </div>
                    <div className="w-[8%] capitalize truncate text-[#000] font-normal text-[14px]">
                      {user?.status}
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center py-28 px-6 bg-white border-2 border-gray-100 relative overflow-hidden">
                  {/* Subtle Background Security Pattern */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none">
                    <ShieldCheck size={400} className="text-[#2A8C52]" />
                  </div>
                  {/* Icon Container with ZipGo Green glow */}
                  <div className="relative mb-8 z-10">
                    <div className="absolute inset-0 bg-[#2A8C52] blur-[35px] opacity-15 rounded-full scale-150" />

                    <div className="relative w-24 h-24 bg-white rounded-[28px] flex items-center justify-center border border-gray-100 shadow-2xl shadow-gray-200/40">
                      <UserCog
                        size={42}
                        className="text-[#2A8C52] opacity-90"
                      />

                      {/* Security Badge */}
                      <div className="absolute -top-1 -right-1 w-9 h-9 bg-[#2A8C52] rounded-xl flex items-center justify-center border-4 border-white shadow-lg">
                        <Lock size={16} className="text-white" fill="white" />
                      </div>
                    </div>
                  </div>
                  {/* Content */}
                  <div className="max-w-md text-center relative z-10">
                    <h3 className="text-gray-900 font-extrabold text-2xl tracking-tight">
                      No Admin Users Found
                    </h3>
                    <p className="text-gray-500 mt-3 text-[15px] leading-relaxed">
                      The administrator directory is currently empty. You should
                      assign roles to your team to start managing permissions
                      and system operations securely.
                    </p>
                  </div>
                  {/* Action Buttons */}
                  <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto relative z-10">
                    <button
                      onClick={toggleAddUser}
                      className="sm:w-auto px-8 py-3.5 bg-[#000000] text-white text-sm font-bold rounded-2xl hover:bg-[#227042] hover:shadow-xl hover:shadow-green-900/20 transition-all flex items-center justify-center gap-2 group"
                    >
                      <UserPlus
                        size={18}
                        className="group-hover:scale-110 transition-transform"
                      />
                      Add Admin Member
                    </button>

                    <button className="sm:w-auto px-8 py-3.5 bg-white text-gray-600 text-sm font-bold rounded-2xl border border-gray-200 hover:bg-gray-50 transition-all flex items-center justify-center gap-2 shadow-sm">
                      <Search size={18} />
                      View All Roles
                    </button>
                  </div>
                </div>
              )}
              <div className="h-[50px] mb-[20px] flex items-center justify-between">
                <div className="flex items-center gap-[10px]">
                  <p className="text-[15px] text-[#5C5C5C] font-normal">
                    {start}–{end} of {totalItems}
                  </p>
                  <p className="text-[15px] text-[#5C5C5C] font-normal">
                    Row/Page:
                  </p>
                  <p className="text-[15px] text-[#5C5C5C] font-normal">
                    {page}/{totalPages}
                  </p>
                  <select
                    className="h-[35px] px-[7px] text-[12px] w-[100px]"
                    name="row"
                    id="row"
                    value={limit}
                    onChange={(e) => setLimit(e.target.value)}
                  >
                    <option value="10">10 items</option>
                    <option value="20">20 items</option>
                    <option value="25">25 items</option>
                  </select>
                </div>
                <div>
                  <Pagination
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </>
          )}
          {activeTab === "roles" && (
            <>
              <div className="flex my-[20px] items-end justify-between">
                <div>
                  <p className="text-[#222222] text-[20px] font-semibold">
                    Manage Roles
                  </p>
                  <p className="text-[#000000] font-light text-[14px]">
                    Roles are reusable set of permissions that you can quickly
                    apply to your staff users.
                  </p>
                </div>
                {hasPermission(
                  auth?.roles,
                  "54682f2d-95fa-4794-2d17-01f23addb6a6",
                ) && (
                  <button
                    onClick={toggleAddRoleInformation}
                    className="bg-[#000000] h-[40px] rounded-[30px] text-[#ffffff] text-[14px] font-normal px-[20px] flex items-center justify-center gap-[5px]"
                  >
                    <Plus size={16} color="#ffffff" />
                    Create a New Role
                  </button>
                )}
              </div>
              {allRoles.map((role, index) => (
                <div key={role.id}>
                  <div
                    className="h-[60px] mt-[15px] w-full bg-[#F3F3F3] px-[10px] flex items-center justify-between cursor-pointer"
                    onClick={() => toggleExpand(index)}
                  >
                    <div className="flex flex-col">
                      <p className="text-[#222222] text-[16px] leading-none font-medium">
                        {role.name}
                      </p>
                      <p
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleViewUsers(role?.users);
                        }}
                        className="text-[#000000] underline text-[13px] font-medium"
                      >
                        {role?.users?.length} Users
                      </p>
                    </div>
                    <div className="flex items-center gap-[10px]">
                      {hasPermission(
                        auth?.roles,
                        "494bceda-5bbd-334a-ce55-e51488b1b0de",
                      ) && (
                        <Edit
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleEditRoleInformation(role);
                          }}
                          size={16}
                        />
                      )}
                      {hasPermission(
                        auth?.roles,
                        "e34cbe12-59d1-991d-716b-46dd23041219",
                      ) && (
                        <Trash
                          onClick={(e) => {
                            e.stopPropagation();
                            togglePromptDeleteRole(role);
                          }}
                          size={16}
                          color="#000000"
                        />
                      )}
                      <div className="transition-transform duration-200">
                        {expandedIndex === index ? (
                          <ChevronDown color="#222222" size={25} />
                        ) : (
                          <ChevronRight color="#222222" size={25} />
                        )}
                      </div>
                    </div>
                  </div>

                  {expandedIndex === index && (
                    <div className="px-[10px] py-[10px] bg-white text-[14px] text-[#333]">
                      <div>
                        {allModules &&
                          allModules.map((module) => (
                            <div>
                              <p
                                key={module.id}
                                className="text-[#000000] mb-[15px] font-bold text-[16px]"
                              >
                                {module?.name}
                              </p>
                              {module?.permissions?.map((permission) => (
                                <div
                                  key={permission?.id}
                                  className="flex items-center mb-[15px] pl-[20px] justify-between"
                                >
                                  <p className="text-[#000000] font-normal text-[14px]">
                                    {permission?.name}
                                  </p>
                                  <input
                                    type="checkbox"
                                    name="accounts"
                                    id="accounts"
                                    readOnly
                                    checked={checkPermission(role, permission)}
                                  />
                                </div>
                              ))}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
          {activeTab === "permissions" && (
            <>
              <div className="flex my-[20px] items-end justify-between">
                <div className="max-w-[75%]">
                  <p className="text-[#222222] text-[20px] font-semibold">
                    Manage Permissions
                  </p>
                  <p className="text-[#000000] font-light text-[14px]">
                    Permissions define the specific actions a user can perform
                    within the system. They provide fine-grained control over
                    access, ensuring that each user can only interact with the
                    features and data relevant to their role. Permissions are
                    grouped into modules for easy retrieval.
                  </p>
                </div>
                {hasPermission(
                  auth?.roles,
                  "8ae3e13c-8ad8-800d-ea49-4647ddcc22ec",
                ) && (
                  <button
                    onClick={toggleAddModule}
                    className="bg-[#000000] h-[40px] rounded-[30px] text-[#ffffff] text-[14px] font-normal px-[20px] flex items-center justify-center gap-[5px]"
                  >
                    <Plus size={16} color="#ffffff" />
                    Create a module
                  </button>
                )}
              </div>
              {allModules?.map((module) => (
                <div key={module.id} className="mb-[15px]">
                  <div
                    className="flex justify-between items-center cursor-pointer bg-[#F3F3F3] p-[12px] rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleExpandModule(module.id);
                    }}
                  >
                    <p className="text-[#000000] font-bold text-[16px]">
                      {module?.name}
                    </p>
                    <div className="flex items-center gap-[10px]">
                      <PlusCircle
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleAddModulePermission(module);
                        }}
                        size={16}
                        color="#222222"
                        className="cursor-pointer"
                      />
                      <Trash size={16} color="#000000" />
                      {expandedModules[module.id] ? (
                        <ChevronDown size={20} color="#222222" />
                      ) : (
                        <ChevronRight size={20} color="#222222" />
                      )}
                    </div>
                  </div>

                  {expandedModules[module.id] && (
                    <div className="pl-[20px] mt-[10px] bg-white rounded">
                      {module?.permissions?.map((permission) => (
                        <div
                          key={permission?.id}
                          className="flex items-center mb-[10px] justify-between border-b border-gray-200 py-[6px]"
                        >
                          <p className="text-[#000000] font-normal text-[14px]">
                            {permission?.name}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Users;
